import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import ErrorMessage from 'components/share/ErrorMessage'
import { PopularMediaWidgetsType } from '../../types'

const PopularMediaEmptyResultGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetSetting = useDashboardWidgetSetting<PopularMediaWidgetsType>(widgetId)
  const { t } = useTranslation()

  if ('mediaDomains' in widgetSetting && widgetSetting.mediaDomains!.length === 0) {
    return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>
  }
  return children
}

export default PopularMediaEmptyResultGuard
